import ArrowBack from '@mui/icons-material/ArrowBack';
import { capitalize, Grid2 as Grid, Stack, Typography } from '@mui/material';
import type { FC } from 'react';
import { Button } from '~/components/atoms/Button';
import { HOME_PATH } from '~/constants';
import { getPlural } from '~/utils/stringUtils';
import type { NotFoundProps } from './NotFound.types';

/**
 * Displays a "not found" message and return link for pages or custom types.
 */
export const NotFound: FC<NotFoundProps> = ({ description, heading, linkLabel, linkTo, type = 'page' }) => {
  const headingText = heading || `${capitalize(type)} not found`;
  const typePlural = type === 'page' ? 'home' : getPlural(type);
  const descriptionText =
    description ||
    `We couldn't find the ${type} you're looking for. Try checking the URL or heading back to the ${typePlural} page.`;

  return (
    <Grid container justifyContent="center">
      <Grid size={{ md: 6 }}>
        <Stack px={5} py={8} gap={2} textAlign="center" alignItems="center">
          <Typography variant="h3">{headingText}</Typography>
          <Typography variant="body1">{descriptionText}</Typography>
          <Button variant="contained" to={linkTo || HOME_PATH} startIcon={<ArrowBack />}>
            {linkLabel || `Back to ${typePlural}`}
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
};
